import axios from "vue-app/utils/axios";
import { DTOIntegrationSynchronizationProgressResponse } from "../dto";

const getIntegrationSynchronizationProgress = async () => {
  const { data } = await axios.get<DTOIntegrationSynchronizationProgressResponse>(
    `/integration/synchronization/progress`
  );

  return data;
};

const postIntegrationApprove = async (integrationSynchronizationQueueId: number, contactsToImport: number) => {
  await axios.put(`/integration/synchronization/` + integrationSynchronizationQueueId + `/approve/agent`, {
    contactsToImport: contactsToImport,
  });
};

export { getIntegrationSynchronizationProgress, postIntegrationApprove };
